import { z } from 'zod';
const timeTrackingAnalyticsSchema = z.object({
    approvedMissions: z.number(),
    approvedShifts: z.number(),
    approvedHours: z.number(),
});
const getTimeTrackingAnalyticsResponseSchema = z.union([timeTrackingAnalyticsSchema, z.void()]);
export const getTimeTrackingAnalyticsFunctionDef = {
    name: 'getTimeTrackingAnalytics',
    requestSchema: z.null(),
    responseSchema: getTimeTrackingAnalyticsResponseSchema,
};
